import { render, staticRenderFns } from "./coloredNotificationBlock.vue?vue&type=template&id=e9311b4e&scoped=true&"
import script from "./coloredNotificationBlock.vue?vue&type=script&lang=js&"
export * from "./coloredNotificationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9311b4e",
  null
  
)

export default component.exports